import { connect } from 'react-redux';
import { getCurrentQuery } from '@hc/redux-saga-router-plus/hclib/selectors';
import { routeChange } from '@hc/redux-saga-router-plus/hclib/actions';

import {
  getReportStatusHcVersionIsLoadedInitial,
  getReportStatusInitialLoadComplete
} from 'selectors/report-status';
import { getIsLessThanSmallMedium } from 'selectors/match-media';
import { showCobrandingData } from 'selectors/personalization';
import { getSubjectAdjusted, getSubjectDefault } from 'selectors/subject';
import {
  getPhotosByAddressIdExludingMapTile,
  getPhotosLoadingByAddressId
} from 'selectors/photos';
import { getIsAvmHcEmpty } from 'selectors/avms';
import {
  getReportComments,
  getIsEffectiveDateReport
} from 'selectors/property-explorer';
import { getIsAttemptingLoadFullReport } from 'selectors/property-search';
import { getIsReportSaveable } from 'selectors/report-permissions';

import PropertyExplorerPage from 'legacy/pages/PropertyExplorerPage';

const mapStateToProps = (state, ownProps) => {
  const subjectDefault = getSubjectDefault(state);
  const subjectAdjusted = getSubjectAdjusted(state);
  const isEffectiveDateReport = getIsEffectiveDateReport(state);
  const photos = getPhotosByAddressIdExludingMapTile(subjectDefault.addressId)(
    state
  );
  const { commentModal, shareModal } = getCurrentQuery(state);
  return {
    subjectAdjusted,
    subjectDefault,
    photos,
    isEffectiveDateReport,
    isPhotosLoading:
      !subjectDefault.addressId ||
      getPhotosLoadingByAddressId(subjectDefault.addressId)(state),
    isAvmHcEmpty: getIsAvmHcEmpty(state),
    showCobranding: showCobrandingData(state),
    reportIsLoadedHc: getReportStatusHcVersionIsLoadedInitial(state),
    reportIsLoaded:
      getReportStatusInitialLoadComplete(state) ||
      getIsAttemptingLoadFullReport(state),
    isMobile: getIsLessThanSmallMedium(state),
    isReadOnly: !getIsReportSaveable(state),
    commentValue: getReportComments(state),
    commentModal,
    shareModal
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClose: () => {
      dispatch(
        routeChange({
          options: { inherit: true, replace: true },
          query: { commentModal: undefined }
        })
      );
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyExplorerPage);
